import { FlightType } from "src/stores/wizard/state/typings";

export const FlightTypeCodeMap = {
  [FlightType.ROUND_TRIP]: "ROUND_TRIP",
  [FlightType.ONE_WAY]: "ONE_WAY",
  [FlightType.MULTI_CITY]: "MULTIPLE_DESTINATION",
  [FlightType.DEFAULT]: "ROUND_TRIP",
};
